<div class="card-modal p-2">
    <header class="card-gs-modal-header d-flex justify-content-between p-3">
        <h4 class="card-modal-title">
            {{ 'VEHICLE_DISABLE_SCHEDULE.TITLE' | translate }}
        </h4>
            
        <button type="button" class="btn-close pull-right" aria-label="Close" (click)="bsModalRef.hide()"></button>
    </header>

    <content>
        <p class="text-muted px-3">{{ 'VEHICLE_DISABLE_SCHEDULE.DESCRIPTION' | translate }}</p>
        <form class="mx-1" [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="row m-0 mb-4">
                <!-- Time Slots -->
                <div class="col-12">
                    <h5>{{ 'VEHICLE_DISABLE_SCHEDULE.TIME_SLOTS' | translate }}</h5>
                    
                    <!-- Fasce orarie -->
                    <div formArrayName="timeSlots">
                        @for (slot of timeSlotsFormArray.controls; track $index) {
                            <div [formGroupName]="$index" class="time-slot-row d-flex align-items-center mb-2">
                                <select class="form-select me-2" formControlName="dayOfWeek">
                                    @for (day of weekDays; track day.id) {
                                        <option [value]="day.id">{{ day.name }}</option>
                                    }
                                </select>
                                
                                <div class="d-flex align-items-center me-2">
                                    <input type="time" class="form-control" [value]="getTimeStringValue($index, 'startTime')" 
                                        (change)="onTimeChange($event, 'startTime', $index)">
                                    <span class="mx-2">-</span>
                                    <input type="time" class="form-control" [value]="getTimeStringValue($index, 'endTime')" 
                                        (change)="onTimeChange($event, 'endTime', $index)">
                                </div>
                                
                                <button type="button" class="btn-outline-gs-danger" (click)="removeTimeSlot($index)" 
                                    [disabled]="timeSlotsFormArray.length <= 1">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        }
                    </div>
                    
                    <button type="button" class="btn-outline-gs-primary" (click)="addTimeSlot()">
                        <i class="bi bi-plus"></i> {{ 'VEHICLE_DISABLE_SCHEDULE.ADD_TIME_SLOT' | translate }}
                    </button>
                </div>
            </div>

            <div class="row m-0 mb-4">
                <!-- Mesi attivi -->
                <div class="col-12">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <h5 class="mb-0">{{ 'VEHICLE_DISABLE_SCHEDULE.ACTIVE_MONTHS' | translate }}</h5>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch" id="selectAllMonths" 
                                (change)="toggleAllMonths($event)">
                            <label class="form-check-label text-secondary" for="selectAllMonths">
                                {{ 'VEHICLE_DISABLE_SCHEDULE.SELECT_ALL_MONTHS' | translate }}
                            </label>
                        </div>
                    </div>
                    <div class="months-container d-flex flex-wrap" formArrayName="activeMonths">
                        @for (month of months; track month.id) {
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" [formControlName]="month.id - 1" [id]="'month-' + month.id">
                                <label class="form-check-label" [for]="'month-' + month.id">{{ month.name }}</label>
                            </div>
                        }
                    </div>
                </div>
            </div>

            <div class="row m-0 mb-3">
                <!-- Gruppi utente -->
                <div class="col-12">
                    <h5>{{ 'VEHICLE_DISABLE_SCHEDULE.USER_GROUPS' | translate }}</h5>
                    <div class="my-3">
                        <user-group-autocomplete
                        (onSelectedItem)="onUserGroupSelected($event)" />
                        <p class="mt-2 text-muted">{{ 'VEHICLE_DISABLE_SCHEDULE.USER_GROUPS_DESCRIPTION' | translate }}</p>
                    </div>
                    
                    <div class="d-flex flex-wrap gap-2 mt-2" *ngIf="selectedUserGroups && selectedUserGroups.length > 0">
                        <button *ngFor="let group of selectedUserGroups" type="button" class="btn-gs-secondary-icon">
                            {{group?.name}}
                            <button type="button" class="btn-close" aria-label="Close" (click)="removeUserGroup(group.id)"></button>
                        </button>
                    </div>
                </div>
            </div>

            <div class="row m-0 mb-3">
                <!-- Note -->
                <div class="col-12">
                    <label for="note" class="form-label">{{ 'MODAL_VEHICLE_STATUS.NOTE' | translate }}</label>
                    <textarea id="note" class="form-control" rows="3" formControlName="note"></textarea>
                </div>
            </div>

            <div class="row m-0 mt-4 pb-3">
                <div class="col-12 d-flex justify-content-end">
                    <button type="button" class="btn-gs-secondary me-2" (click)="bsModalRef.hide()">
                        {{ 'ACTIONS.CANCEL' | translate }}
                    </button>
                    <button type="submit" class="btn-gs-primary" [disabled]="!form.valid || isLoading">
                        @if (isLoading) {
                            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        }
                        {{ 'ACTIONS.SAVE' | translate }}
                    </button>
                </div>
            </div>
        </form>
    </content>
</div> 